import React from 'react';
import { usePRD3040_R01Store } from '../Store_PRD3040_R01';

interface SubtotalControlProps {
    className?: string;
}

export const SubtotalControl: React.FC<SubtotalControlProps> = ({ className = '' }) => {
    const {
        PRD3040_R01showSubtotals: showSubtotals,
        setPRD3040_R01ShowSubtotals: setShowSubtotals,
    } = usePRD3040_R01Store();
    const checkboxId = 'PRD3040_R01_showSubtotals';

    return (
        <div className={`flex items-center gap-2 px-4 py-1 ${className}`}>
            <label
                htmlFor={checkboxId}
                className="text-s cursor-pointer select-none"
            >
                소계 표시
            </label>
            <input
                id={checkboxId}
                type="checkbox"
                checked={showSubtotals}
                onChange={(event) => setShowSubtotals(event.target.checked)}
                className="h-4 w-4 cursor-pointer accent-blue-600"
            />
        </div>
    );
};
